import { useParams, Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { ArrowLeft, Heart } from 'lucide-react'
import Button from '../components/Button'
import { db } from '../lib/supabase'

function PlayerGarden() {
  const { playerId } = useParams()
  const [player, setPlayer] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadPlayerData()
  }, [playerId])

  const loadPlayerData = async () => {
    try {
      setLoading(true)
      const profile = await db.getProfile(playerId)
      setPlayer(profile)
    } catch (error) {
      console.error('Failed to load player data:', error)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-green-600"></div>
      </div>
    )
  }

  if (!player) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Joueur introuvable
          </h2>
          <Link to="/community">
            <Button>Retour à la communauté</Button>
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <Link to="/community">
          <Button variant="outline" className="flex items-center gap-2 mb-8">
            <ArrowLeft size={20} />
            Retour
          </Button>
        </Link>

        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          {/* Player Header */}
          <div className="bg-gradient-to-r from-green-500 to-green-600 p-8 text-white">
            <div className="flex items-center gap-4">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center text-4xl">
                {player.avatar_url ? (
                  <img src={player.avatar_url} alt="Avatar" className="w-full h-full rounded-full" />
                ) : (
                  '🌱'
                )}
              </div>
              <div>
                <h1 className="text-3xl font-bold">{player.username || 'Jardinier'}</h1>
                {player.bio && (
                  <p className="text-green-100 mt-2">{player.bio}</p>
                )}
              </div>
            </div>
          </div>

          {/* Plant Display */}
          <div className="p-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Plante exposée</h2>
            
            <div className="bg-gradient-to-b from-sky-300 to-green-100 rounded-xl aspect-video flex items-center justify-center mb-6">
              <div className="text-8xl">🌿</div>
            </div>

            <div className="flex items-center justify-center gap-4">
              <button className="flex items-center gap-2 bg-red-100 hover:bg-red-200 text-red-600 px-6 py-3 rounded-lg font-bold transition">
                <Heart size={24} />
                J'aime
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PlayerGarden
